export const dataHooks = {
    link: 'announcementModalLayout-link',
};
//# sourceMappingURL=constants.js.map